import React, { useState } from 'react';
import { Modal, Button, Row, Col, FormGroup, Form, FormControl } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export default function UpdatePasswordModal(props) {
    const { updatePassword, handlePasswordToggleModal, showCurrent, passwordCheck, buttonColor } = props;
    const schema = showCurrent
        ? yup.object().shape({
              password: yup.string().required('Password is required').min(8, 'Password must be at least 8 characters'),
              confirmPassword: yup.string().when('password', {
                  is: (val) => !!(val && val.length > 0),
                  then: yup.string().oneOf([yup.ref('password')], 'confirm password should be same as password'),
              }),
          })
        : yup.object().shape({
              password: yup.string().required('Password is required').min(8, 'Password must be at least 8 characters'),
              confirmPassword: yup.string().when('password', {
                  is: (val) => !!(val && val.length > 0),
                  then: yup.string().oneOf([yup.ref('password')], 'confirm password should be same as password'),
              }),
          });

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });
    // The Controller this replaces ignored its render argument, so the field was rendered but
    // never registered and `currentPassword` reached the server undefined.
    const currentPasswordField = register('currentPassword');
    const [currentPasswordError, setCurrentPasswordError] = useState(false);

    const onSubmit = async (data) => {
        !currentPasswordError && updatePassword(data);
    };

    const onCheckPassword = async (password) => {
        try {
            const res = await passwordCheck(password);
            if (res.data === false) setCurrentPasswordError(true);
            else {
                setCurrentPasswordError(false);
            }
        } catch (err) {
            console.log('error', err);
        }
    };
    return (
        <div>
            <Modal size="md" show={true} onHide={() => () => handlePasswordToggleModal(false)}>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Modal.Header>
                        <Modal.Title>Update Password</Modal.Title>
                        <i className="fas fa-times closeButton" onClick={() => handlePasswordToggleModal(false)} />
                    </Modal.Header>
                    <Modal.Body>
                        {showCurrent ? (
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Form.Label>Current Password</Form.Label>
                                        <Form.Control
                                            type="password"
                                            placeholder="Current Password"
                                            id="currentPassword"
                                            isInvalid={Boolean(errors?.currentPassword) || currentPasswordError}
                                            {...currentPasswordField}
                                            onBlur={(e) => {
                                                currentPasswordField.onBlur(e);
                                                onCheckPassword(e.target.value);
                                            }}
                                        />
                                        <FormControl.Feedback type="invalid">
                                            {currentPasswordError
                                                ? 'Incorrect Password'
                                                : errors && errors.currentPassword?.message}
                                        </FormControl.Feedback>
                                    </FormGroup>
                                </Col>
                            </Row>
                        ) : (
                            ''
                        )}
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder="Password"
                                        name="password"
                                        isInvalid={errors && errors.password}
                                        {...register('password')}
                                    />

                                    <FormControl.Feedback type="invalid">
                                        {errors && errors.password?.message}
                                    </FormControl.Feedback>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Form.Label>Confirm Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder="Confirm Password"
                                        name="confirmPassword"
                                        isInvalid={errors && errors.confirmPassword}
                                        {...register('confirmPassword')}
                                    />
                                    <FormControl.Feedback type="invalid">
                                        {errors && errors.confirmPassword?.message}
                                    </FormControl.Feedback>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="primary"
                            className="btn w-25 pt-2 pb-2"
                            style={{ backgroundColor: buttonColor, borderColor: 'transparent' }}
                            onClick={() => handlePasswordToggleModal(false)}
                        >
                            Cancel
                        </Button>
                        <Button type="submit" variant="secondary" className="btn pt-2 pb-2">
                            Update Password
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </div>
    );
}
